import Pui9HttpRequests from 'pui9-requests';

const accept = {
	id: 'accept',
	selectionType: 'single',
	label: 'appointment.actions.accept',
	functionality: null,
	showInForm: true,
	checkAvailability: function (registries) {
		var role = window.localStorage.getItem('workingRole');
		if (role == 'ADMIN') {
			return true;
		} else if (role == 'EXHIBITOR') {
			return registries.length > 0 && registries[0].appostatus == 'PENDING_EXHIBITOR';
		} else if (role == 'VISITOR') {
			return registries.length > 0 && registries[0].appostatus == 'PENDING_VISITOR';
		}
		return false;
	},
	runAction: function (action, model, registries) {
		var title = this.$puiI18n.t('puiaction.notifyTitle') + ' > ' + this.$puiI18n.t(action.label);

		this.$puiRequests.getRequest(
			this.$store.getters.getModelByName('appointment').url.accept,
			{
				appoid: registries[0].appoid
			},
			(response) => {
				console.log(response);
				this.$puiEvents.$emit('onPui-action-running-ended-' + model.name);
				var message = this.$puiI18n.t('puiaction.notifySuccess');
				this.$puiNotify.success(message, title);
			},
			(error) => {
				console.log(error);
				this.$puiEvents.$emit('onPui-action-running-ended-' + model.name);
				var message = this.$puiI18n.t('puiaction.notifyError');
				this.$puiNotify.error(message, title);
			}
		);
	}
};
const reject = {
	id: 'reject',
	selectionType: 'single',
	label: 'appointment.actions.reject',
	functionality: null,
	showInForm: true,
	checkAvailability: function (registries) {
		var role = window.localStorage.getItem('workingRole');
		if (role == 'ADMIN') {
			return true;
		} else if (role == 'EXHIBITOR') {
			return registries.length > 0 && (registries[0].appostatus == 'PENDING_EXHIBITOR' || registries[0].appostatus == 'ACCEPTED');
		} else if (role == 'VISITOR') {
			return registries.length > 0 && (registries[0].appostatus == 'PENDING_VISITOR' || registries[0].appostatus == 'ACCEPTED');
		}
		return false;
	},
	runAction: function (action, model, registries) {
		var title = this.$puiI18n.t('puiaction.notifyTitle') + ' > ' + this.$puiI18n.t(action.label);

		this.$puiRequests.getRequest(
			this.$store.getters.getModelByName('appointment').url.reject,
			{
				appoid: registries[0].appoid
			},
			(response) => {
				console.log(response);
				this.$puiEvents.$emit('onPui-action-running-ended-' + model.name);
				var message = this.$puiI18n.t('puiaction.notifySuccess');
				this.$puiNotify.success(message, title);
			},
			(error) => {
				console.log(error);
				this.$puiEvents.$emit('onPui-action-running-ended-' + model.name);
				var message = this.$puiI18n.t('puiaction.notifyError');
				this.$puiNotify.error(message, title);
			}
		);
	}
};

export async function acceptHash(profile, hash) {
	const controller = `/appointment/acceptHash?profile=${profile}&hash=${hash}`;
	let data = [];
	await Pui9HttpRequests.getRequest(
		controller,
		null,
		(response) => {
			if (response) {
				data = response.data;
			}
		},
		(error) => {
			if (error) {
				data = error;
			}
		}
	);

	return data;
}

export async function rejectHash(profile, hash) {
	const controller = `/appointment/rejectHash?profile=${profile}&hash=${hash}`;
	let data = [];
	await Pui9HttpRequests.getRequest(
		controller,
		null,
		(response) => {
			if (response) {
				data = response.data;
			}
		},
		(error) => {
			if (error) {
				data = error;
			}
		}
	);

	return data;
}

export default {
	gridactions: [accept, reject],
	formactions: [accept, reject]
};
